import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Icon, Table } from 'semantic-ui-react';
import Form from './Form';
import CredentialsRowPlacements from './CredentialsRowPlacements';
import { EmptyRow } from 'core/app/views';

import App from 'apps/app';
import LineItem from 'apps/lineitem';
import Placement from 'apps/placement';
import UserStore from 'core/user/store';
import AppHelpers from '../../app/helpers';
import NetworkHelpers from 'apps/network/helpers';
import Helpers from '../helpers';
import Store from '../store';
import { sortArrayByDirection } from 'utils/helpers';

const defaultState = {
  column: null,
  direction: null,
  data: [],
  instance: {
    id: '',
    active: true,
    fields: [],
  },
};

class Credentials extends Component {
  constructor(props) {
    super(props);
    this.state = { ...defaultState };
  }

  Items = (existing, appId) => {
    if (existing.length === 0) {
      return <EmptyRow message="No App Credentials" colSpan="12" />;
    }
    const biddingMetrics = this.props?.biddingMetrics || [];
    const biddingBTestMetrics = this.props?.biddingBTestMetrics || [];
    const mappedRows = NetworkHelpers.addBiddingMetrics(
      this.props.abtesttype === 'B' ? biddingBTestMetrics : biddingMetrics,
      existing
    );

    const sortedRows = sortArrayByDirection(mappedRows, this.state.column, this.state.direction);

    return sortedRows.map((entry) => {
      if (entry.id === 'admob') {
        entry = Helpers.admob_google_sso(entry);
      }
      return (
        <CredentialsRowPlacements
          appId={appId}
          rowData={entry}
          key={String(entry.id)}
          removeSource={this.removeInstance.bind(this, entry.id)}
          setSource={this.toggleInstance.bind(this, entry.id)}
          onlySource={existing.length === 1}
          source={entry}
          abtest={this.props.abtest === true}
          loading={this.props.loading}
          editCredentials={this.editCredentials.bind(this)}
          type={this.props.type}
          placement={this.props.placement}
          addPredicate={this.props.addPredicate}
          createRule={this.props.createRule}
          deletePredicate={this.props.deletePredicate}
          deleteRule={this.props.deleteRule}
          editPredicate={this.props.editPredicate}
          getPlacementBiddingLineItems={this.props.getPlacementBiddingLineItems}
          negateRule={this.props.negateRule}
          shouldFetchPlacementLineItems={this.props.shouldFetchPlacementLineItems}
        />
      );
    });
  };

  changeSort(column) {
    if (this.state.column === column) {
      this.setState((state) => {
        return {
          ...state,
          direction: state.direction === 'ascending' ? 'descending' : 'ascending',
        };
      });
    } else {
      this.setState((state) => {
        return {
          ...state,
          column: column,
          direction: 'descending',
        };
      });
    }
  }

  selectNetwork(e, event) {
    const { app, type, networkSchemas } = this.props;
    const networkId = event.value;
    const schema = networkSchemas[networkId];
    this.setState((state) => {
      return {
        ...state,
        instance: {
          id: networkId,
          fields:
            type === 'app_credentials'
              ? Helpers.createAppCredentials(app, networkId, schema)
              : Helpers.createPlacementCredentials(app, networkId, schema),
        },
      };
    });
  }

  addInstance() {
    const network = this.state.instance.id;
    const { create, app, placement = null, networkType, networkSchemas } = this.props;
    if (placement) {
      let placementFields = networkSchemas[network].placement_credentials || [];
      let values = this.state.instance.fields.filter((f) =>
        placementFields.find((pf) => pf.name === f.name)
      );
      create(app.id, placement.id, { id: network, fields: values });
    } else {
      create(app.id, this.state.instance, networkType);
    }
    this.setState((_state) => {
      return {
        ...defaultState,
      };
    });
  }

  editCredentials(source) {
    const network = source.id;
    const {
      app,
      create,
      editAppCredentials,
      editPlacementCredentials,
      networkSchemas,
      networkType,
      placement = null,
    } = this.props;
    if (placement) {
      let placementFields = networkSchemas[network].placement_credentials || [];
      let values = source.fields.filter((f) => placementFields.find((pf) => pf.name === f.name));
      delete values[0].label;
      values[0].type = 'string';
      // Update credentials for new placements
      if (placement.id === '__new__') {
        create(app.id, placement.id, { id: network, fields: values });
      } else {
        editPlacementCredentials(app.id, placement.id, { id: network, fields: values });
      }
    }
    // TODO: we should check what changes occur within app/placement/both credentials and make the appropiate api calls
    editAppCredentials(app.id, source, networkType);
  }

  removeInstance(networkId) {
    const { app, placement = null, networkType } = this.props;
    if (placement) {
      this.props.delete(app.id, placement.id, networkId);
    } else {
      this.props.delete(app.id, networkId, networkType);
    }
  }

  editInstanceField(e, { name, value }) {
    const fields = this.state.instance.fields;
    const field = fields.find((f) => f.name === name);
    field.value = value;
    this.setState((state) => {
      return {
        ...state,
        instance: {
          ...this.state.instance,
          fields: fields,
        },
      };
    });
  }

  toggleInstance(networkId, e, { value }) {
    const { app, placement = null, edit, networkType } = this.props;
    if (placement) {
      edit(app.id, placement.id, networkId, value === 'true');
    } else {
      edit(app.id, networkId, networkType, value === 'true');
    }
  }

  isValid() {
    const { fields, id } = this.state.instance;
    const { type } = this.props;
    // no selected networks
    if (fields.length === 0) return false;
    // not all fields are filled

    if (type === 'placement_credentials' && id === 'google_googlebidding') {
      const adUnitIdField = fields.find((field) => field.name === 'ad_unit_id');
      return adUnitIdField?.value !== undefined && adUnitIdField?.value.trim() !== '';
    }

    for (const f of fields) {
      if (f.name == 'price_points') {
        // check for amazon aps csv line items
        if (f?.value === undefined || f?.value?.length === 0) {
          return false;
        }
      } else if (f?.value === undefined || f?.value.trim() === '') return false;
    }
    // all fields are filled
    return true;
  }

  toUICredentials(creds) {
    let list = [];
    const { type, app, networkType, networkSchemas } = this.props;
    for (const networkId of Object.keys(creds)) {
      let isActive = false;
      let networkState = AppHelpers.getNetworkState(app, networkId, networkType);
      let fieldNames = Object.keys(creds[networkId]).filter((n) => n !== 'active');
      // SG-1843: disable app credentials when in placement credential view
      const placementCreds = networkSchemas[networkId].placement_credentials.map((f) => f.name);

      if (networkState) {
        isActive = type === 'app_credentials' ? networkState.active : creds[networkId].active;
        list.push({
          id: networkId,
          key: networkId,
          name: Helpers.getName(networkId),
          active: isActive,
          fields: fieldNames.map((f) => ({
            label: Helpers.getFieldName(networkId, f),
            value: creds[networkId][f],
            name: f,
            disabled: type === 'placement_credentials' && placementCreds.includes(f) ? false : true,
          })),
        });
      }
    }
    return list;
  }

  getExistingCredentials() {
    const { type, app, placement } = this.props;
    const appCreds = AppHelpers.getAppCredentials(app);
    const plcCreds = placement && placement.credentials ? placement.credentials : {};
    let creds = {};
    if (type === 'placement_credentials') {
      // combine app and placement credentials values
      _.forIn(plcCreds, (values, network) => {
        creds[network] = {
          ...appCreds[network],
          ...values,
        };
      });
    } else {
      creds = appCreds;
    }
    return this.toUICredentials(creds);
  }

  getActionText = (type) =>
    type === 'app_credentials' ? 'add your app credentials from' : 'add your placement info from';

  render() {
    const {
      abtest,
      app,
      appId,
      disabled,
      options,
      networkType,
      type,
      placement,
      isBetaTestAccount,
    } = this.props;
    const existing = this.getExistingCredentials();
    const selected = this.state.instance;

    const formProps = {
      abtest: abtest,
      action: this.getActionText(type),
      add: this.addInstance.bind(this),
      appPlatform: this.props?.app?.platform,
      appId: app?.id || appId,
      disabled: disabled,
      edit: this.editInstanceField.bind(this),
      fields: selected.fields || [],
      isValid: this.isValid(),
      network: selected.id,
      networkType,
      options: options,
      placement: placement,
      select: this.selectNetwork.bind(this),
      type,
      isBetaTestAccount: isBetaTestAccount,
    };

    let credentials = existing ? this.Items(existing, app?.id) : [];
    const shouldDisplayAddition = options.unused?.length > 0;

    const displaySort = (isSorted) =>
      isSorted ? (
        <Icon name={`sort ${this.state.direction}`} />
      ) : (
        <Icon name="sort" style={{ color: 'rgba(0,0,0,0.3' }} />
      );

    return (
      <div>
        <div className="bidding-table-container">
          <Table sortable structured unstackable className="bidding-table">
            <Table.Header style={{ width: '100%' }}>
              <Table.Row className="bidding-table header-row">
                <Table.HeaderCell className="bidding-header activecolumn">Active</Table.HeaderCell>
                <Table.HeaderCell
                  className="bidding-header networkcolumn"
                  onClick={() => this.changeSort('name')}
                >
                  Network {displaySort(this.state.column === 'name')}
                </Table.HeaderCell>
                <Table.HeaderCell
                  className="bidding-header earningscolumn"
                  onClick={() => this.changeSort('earnings')}
                >
                  Earnings {displaySort(this.state.column === 'earnings')}
                </Table.HeaderCell>
                <Table.HeaderCell
                  className="bidding-header attemptscolumn"
                  onClick={() => this.changeSort('attempts')}
                >
                  Attempts {displaySort(this.state.column === 'attempts')}
                </Table.HeaderCell>
                <Table.HeaderCell
                  className="bidding-header bidscolumn"
                  onClick={() => this.changeSort('bids')}
                >
                  Bids {displaySort(this.state.column === 'bids')}
                </Table.HeaderCell>
                <Table.HeaderCell
                  className="bidding-header winscolumn"
                  onClick={() => this.changeSort('wins')}
                >
                  Fills {displaySort(this.state.column === 'wins')}
                </Table.HeaderCell>
                <Table.HeaderCell
                  className="bidding-header impressionscolumn"
                  onClick={() => this.changeSort('impressions')}
                >
                  Impressions {displaySort(this.state.column === 'impressions')}
                </Table.HeaderCell>
                <Table.HeaderCell
                  className="bidding-header ecpmcolumn"
                  onClick={() => this.changeSort('ecpm')}
                >
                  eCPM {displaySort(this.state.column === 'ecpm')}
                </Table.HeaderCell>
                <Table.HeaderCell
                  className="bidding-header bidratecolumn"
                  onClick={() => this.changeSort('bidRate')}
                >
                  Bid Rate {displaySort(this.state.column === 'bidRate')}
                </Table.HeaderCell>
                <Table.HeaderCell
                  className="bidding-header winratecolumn"
                  onClick={() => this.changeSort('winRate')}
                >
                  Fill Rate {displaySort(this.state.column === 'winRate')}
                </Table.HeaderCell>
                <Table.HeaderCell
                  className="bidding-header showratecolumn"
                  onClick={() => this.changeSort('showRate')}
                >
                  Show Rate {displaySort(this.state.column === 'showRate')}
                </Table.HeaderCell>
                <Table.HeaderCell
                  className="bidding-header clickscolumn"
                  onClick={() => this.changeSort('showRate')}
                >
                  Clicks {displaySort(this.state.column === 'clicks')}
                </Table.HeaderCell>
                <Table.HeaderCell
                  className="bidding-header ctrcolumn"
                  onClick={() => this.changeSort('ctr')}
                >
                  CTR {displaySort(this.state.column === 'ctr')}
                </Table.HeaderCell>
                <Table.HeaderCell className="bidding-header morecolumn"></Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>{credentials}</Table.Body>
          </Table>
        </div>
        {shouldDisplayAddition && (
          <div className="bidding-table-footer">
            <Form {...formProps} />
          </div>
        )}
      </div>
    );
  }
}

const props = (state, ownProps) => {
  return {
    biddingMetrics: Placement.Store.getBiddingMetrics(state),
    biddingBTestMetrics: Placement.Store.getBTestBiddingMetrics(state),
    networkSchemas: Store.getSchema(state),
    networkType: ownProps.networkType || 'bidding',
    isBetaTestAccount: UserStore.isBetaTestAccount(state),
    shouldFetchPlacementLineItems: Placement.Store.shouldFetchPlacementLineItems(state),
  };
};

const dispatches = {
  ...App.Actions,
  addPredicate: LineItem.Actions.addPredicate,
  createRule: LineItem.Actions.createRule,
  deletePredicate: LineItem.Actions.deletePredicate,
  deleteRule: LineItem.Actions.deleteRule,
  editPredicate: LineItem.Actions.editPredicate,
  getPlacementBiddingLineItems: Placement.Actions.fetchPlacementBiddingLineItems,
  negateRule: LineItem.Actions.negateRule,
  editAppCredentials: App.Actions.editAppCredentials,
  editPlacementCredentials: Placement.Actions.editPlacementCredentials,
};

export default connect(props, dispatches)(Credentials);
